import * as React from "react";
import { onlineViewerStore } from "Stores/OnlineViewerStore";
import { Loader } from "./General/Loader";
import { observer } from "mobx-react";
import { ViewerModal } from "./ViewerModal";
import { viewFileFullscreen, ViewerType } from "Pages/ViewFullscreen/viewFileFullscreen";
import { projectsDataStore } from "Stores";

interface OnlineViewerIframeProps {
  loading: boolean;
  src: string;
}

export class OnlineViewerIframe extends React.Component<OnlineViewerIframeProps> {
  iframeRef: React.RefObject<HTMLIFrameElement>;
  constructor(props: OnlineViewerIframeProps) {
    super(props);
    this.iframeRef = React.createRef();
  }

  componentWillUnmount() {
    this.releaseLicense();
  }

  releaseLicense = (origin: string = "*") => {
    try {
      if (this.iframeRef.current) {
        this.iframeRef.current.contentWindow.postMessage("releaseLicense", origin);
      }
    } catch (error) {
      // do nothing
    }
  };

  render() {
    const { loading, src = "" } = this.props;
    if (loading) {
      return <Loader />;
    }

    return (
      <div className="online-viewer--wrap">
        <iframe title="Online Viewer" ref={this.iframeRef} src={src} />
      </div>
    );
  }
}

export const OnlineViewer = observer(
  class OnlineViewer extends React.Component {
    viewerRef: React.RefObject<OnlineViewerIframe>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props: any) {
      super(props);
      this.viewerRef = React.createRef();
    }

    handleExit = async () => {
      await new Promise<void>((res) => {
        let origin = "*";
        try {
          // Attempt to get origin, but this will fail for cross-origin iframes
          origin = this.viewerRef.current?.iframeRef.current?.contentWindow?.location?.origin || "*";
        } catch {
          // Cross-origin iframe - use wildcard origin for postMessage
        }
        this.viewerRef.current?.releaseLicense(origin);
        setTimeout(() => {
          onlineViewerStore.toggleModal();
          res();
        }, 500);
      });
    };

    doFullscreen = () => {
      const fileId = onlineViewerStore.fileId;
      const viewFileFullScreenProps = {
        projectId: projectsDataStore.projectId,
        fileId: fileId,
        viewerType: ViewerType.OV,
        viewerOptions: onlineViewerStore.getOptions,
      };
      onlineViewerStore.toggleModal();
      viewFileFullscreen(viewFileFullScreenProps);
    };

    render() {
      return (
        <ViewerModal
          title={onlineViewerStore.fileName}
          visible={onlineViewerStore.isVisible}
          onCancel={this.handleExit}
          onFullScreen={this.doFullscreen}
        >
          <OnlineViewerIframe
            ref={this.viewerRef}
            loading={onlineViewerStore.state === "LOADING"}
            src={onlineViewerStore.link}
          />
        </ViewerModal>
      );
    }
  }
);
